module.exports = __webpack_public_path__ + "img/11.1a377e3b.png";